import { Autocomplete, Box, TextField } from "@mui/material";
import PlacesAutoComplete, { geocodeByAddress, Suggestion } from "react-places-autocomplete";
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface AddresFieldProps {
    value: string;
    handleFormik: (value: string) => void;
    field: string;
    formik: any;
    label: string;
    searchPostalCodeFromAddres?: boolean;
    fieldPostalCode?: string;
}

const AddresField = ({
    value,
    handleFormik,
    field,
    formik,
    label,
    searchPostalCodeFromAddres,
    fieldPostalCode
}: AddresFieldProps) => {

    const searchPostalCode = (address: any) => {
        geocodeByAddress(address)
            .then(results => {
                results[0]?.address_components?.map((item) => {
                    if (item.types[0] === 'postal_code' && fieldPostalCode) {
                        formik.setFieldValue(fieldPostalCode, item.long_name);
                    }
                })
            })
    }

    return (
        <PlacesAutoComplete
            value={value as string}
            onChange={handleFormik}
        >
            {({ getInputProps, suggestions, loading }) => (
                <div>
                    <Autocomplete
                        fullWidth
                        disableClearable
                        sx={{
                            my: 1
                        }}
                        options={suggestions}
                        loading={loading}
                        value={{ id: 'default', description: value } as Suggestion}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        getOptionLabel={(option) => `${option?.description}`}
                        onChange={(event: any, newValue: Suggestion | null | undefined) => {
                            formik.setFieldValue(field, newValue?.description);
                            if (searchPostalCodeFromAddres) {
                                searchPostalCode(newValue?.description)
                            }
                        }}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                                key={option.id}
                            >
                                <LocationOnIcon sx={{
                                    mr: 1
                                }} />
                                {option.description}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                {...getInputProps({
                                })}
                                label={label}
                            />
                        )}
                    />
                </div>
            )}
        </PlacesAutoComplete>
    )
}


export default AddresField